
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
  @Component
export default class AddTheme extends Vue {
    @Prop() dialogAddZy: boolean
    @Prop() hasList: any
    @Prop() student_id: any
    @Prop() instrumentList: any
    addOccupy: any = {}
    themeList: any = []
    list: any = []
    newList: any = []
    getInstrument: string = ''

    @Watch('dialogAddZy')
    async getTheme() {
      this.getInstrument = this.instrumentList[0].id
      this.getThemeList()
    }

    async getThemeList() {
      const res: any = await CourseModule.getAllTheme({'instrument_type_id': this.getInstrument})
      if (res.code === 200) {
        this.themeList = res.data
        this.contrast()
      }
    }
    changeInstrument(val) {
      this.getInstrument = val
      this.getThemeList()
    }

    contrast() {
      this.list = []
      let flag = false
      for (var i = 0; i < this.themeList.length; i++) {
        for (var j = 0; j < this.hasList.length; j++) {
          if (this.themeList[i].id === this.hasList[j].id) {
            this.list.push(this.hasList[j].id)
            flag = true
          }
        }
      }
      if (flag) {
        let arr = this.themeList.concat(this.hasList)
        let obj = {}
        this.newList = arr.reduce((cur, next) => {
          obj[next.id] ? '' : obj[next.id] = true && cur.push(next)
          return cur
        }, []) // 设置cur默认类型为数组，并且初始值为空的数组
      } else {
        this.newList = this.themeList
      }
    }

    handleAddZyClose() {
      this.addOccupy.type = 'close'
      this.$emit('occupy-close', this.addOccupy)
    }
    async handleAddZyTrue() {
      let data = {
        list: []
      }
      for (var i = 0; i < this.list.length; i++) {
        data.list.push({ student_id: this.student_id, subject_id: this.list[i] })
      }
      const res: any = await CourseModule.addAllTheme(data)
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: '添加成功'
        })
        this.addOccupy.type = 'true'
        this.$emit('occupy-close', this.addOccupy)
      } else {
        this.$message.error('添加失败')
      }
    }
}
